<template>
    <div id="app" :class="[this.device === 'krust' ? 'krust' : '']">
        <header class="header-min">
            <div class="container">
                <div class="header-top">
                    <router-link class="go-home-site" to="/" v-if="this.$route.path !== '/' && device !== 'mobile'"><span>На главную расписания</span></router-link>

                    <div class="header-top-section">
                        <a href="/" class="logo" v-if="device !== 'krust'"></a> <!--Ссылка на главную ЮГУ-->
                        <a href="/krust/" class="logo" v-if="device === 'krust'"></a> <!--Ссылка на главную КРУСТ-->

                        <div class="notification-box" v-if="notification.no_notifi !== true">
                            <div class="notification small" v-if="notification.show === false" @click="showNotification()"></div>
                            <div class="notification" v-if="notification.show === true">
                                <div class="close-notifi" @click="closeNotification()"></div>
                                <div class="notif-head">Внимание!</div>
                                <div class="notif-text">Экзаменационная сессия групп заочной формы обучения проводится в ОЧНОМ формате.</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>

        <div class="content">
            <router-view></router-view>
        </div>

        <footer class="container">
            <div class="copy">
                © 2022 Югорский государственный университет
                <br>Версия 3.0.0 от 13.07.2022
            </div>
        </footer>
    </div>
</template>

<script>
import axios from 'axios';
import store from "@/store";

export default {
    data() {
        return {
        }
    },

    created() {
        this.getGroupList();
        this.getSubGroupList();
        this.getKindofworks();
        this.getStreamList();
        this.getBuildingsList();
        this.getInstitutsList();
        this.getLecturersList();
        this.getAuditoriumList();
        this.getContenttableoflesson();
        this.setNotification();
    },

    computed: {
        API() {
            return this.$store.getters.getAPI;
        },
        device() {
            return this.$store.getters.getDevice;
        },
        notification() {
            return this.$store.getters.getNotification;
        },
    },

    mounted() {
        if(window.innerWidth <= 768) {
            this.$store.commit('setDevice', 'mobile');
        }
    },

    methods: {
        setNotification() { /*Обработка показа уведомлений*/
            const notifi_obj = {
                no_notifi: true, //Устанавливаем true, если не хотим выводить уведомления
                show: true,
                date: '13.07.2022',
            }
            this.$store.commit('setNotification', notifi_obj);


            let sectionNotif = localStorage.getItem('notification'); /*Запрашиваем состояние notification из localStorage*/
            let actualNotif = this.notification.date; /*Запрашиваем актуальное состояние из vuex*/

            /*Сравниваем, если запись в localStorage = параметру из vuex значит объявление не изменилось, если появляется новое объявление,
            меняем дату во vuex, параметры окажутся не равны, окно с уведомлением вновь активируем, и меняем запись в  localStorage*/

            if(this.notification.show) {
                if(parseInt(sectionNotif) === parseInt(actualNotif) && sectionNotif !== undefined) {
                    if(sectionNotif) {
                        this.notification.show = false
                        //this.$store.commit('setNotification', notification.show = false);
                    } else {
                        this.notification.show = true
                        //this.$store.commit('setNotification', notification.show = true);
                    }
                } else {
                    this.notification.show = true
                    //this.$store.commit('setNotification', notification.show = true);
                    localStorage.setItem('notification', actualNotif);
                }
            } else {
                this.notification.show = false;
            }

        },

        showNotification() {
            //this.$store.commit('setNotification', true);
            this.notification.show = true
        },

        closeNotification() {
            //this.$store.commit('setNotification', false);
            this.notification.show = false
        },

        /*Получение списка групп*/
        getGroupList() {
            axios.get(this.API + 'groups').then(response => {
                this.$store.commit('setGroupList', response.data);
            }).catch(error => {
                console.log(error);
            })
        },

        /*Получение списка подгрупп*/
        getSubGroupList() {
            axios.get(this.API + 'subgroups').then(response => {
                this.$store.commit('setSubGroupList', response.data);
            }).catch(error => {
                console.log(error);
            })
        },

        /*Получение списка типов занятий (лекция, практика)*/
        getKindofworks() {
            axios.get(this.API + 'kindofworks').then(response => {
                this.$store.commit('setKindofworks', response.data);
            }).catch(error => {
                console.log(error);
            })
        },

        /*Получение списка потоков*/
        getStreamList() {
            axios.get(this.API + 'streams').then(response => {
                this.$store.commit('setStreamList', response.data);
            }).catch(error => {
                console.log(error);
            })
        },

        /*Получение списка корпусов*/
        getBuildingsList() {
            axios.get(this.API + 'buildings').then(response => {
                this.$store.commit('setBuildingsList', response.data);
            }).catch(error => {
                console.log(error);
            })
        },

        /*Получение списка институтов*/
        getInstitutsList() {
            axios.get(this.API + 'faculties').then(response => {
                this.$store.commit('setInstitutsList', response.data);
            }).catch(error => {
                console.log(error);
            })
        },

        /*Получение списка преподавателей*/
        getLecturersList() {
            axios.get(this.API + 'lecturers').then(response => {
                this.$store.commit('setLecturersList', response.data);
            }).catch(error => {
                console.log(error);
            })
        },

        /*Получение списка аудиторий*/
        getAuditoriumList() {
            axios.get(this.API + 'auditoriums').then(response => {
                this.$store.commit('setAuditoriumList', response.data);
            }).catch(error => {
                console.log(error);
            })
        },

        /*Получение списка аудиторий*/
        getContenttableoflesson() {
            axios.get(this.API + 'contenttableoflesson').then(response => {
                this.$store.commit('setContenttableoflesson', response.data);
            }).catch(error => {
                console.log(error);
            })
        },

    },

    watch: {

    },
}

</script>

<style>
@import 'assets/bootstrap/css/bootstrap.css';
</style>

<style lang="scss">
@font-face {
    font-family: 'Montserrat'; /* Имя шрифта */
    src: url('./assets/fonts/Montserrat/Montserrat-Regular.otf'); /* Путь к файлу со шрифтом */
    font-weight: normal;
}

@font-face {
    font-family: 'Montserrat'; /* Имя шрифта */
    src: url('./assets/fonts/Montserrat/Montserrat-Medium.otf'); /* Путь к файлу со шрифтом */
    font-weight: 500;
}

@font-face {
    font-family: 'Montserrat'; /* Имя шрифта */
    src: url('./assets/fonts/Montserrat/Montserrat-SemiBold.otf'); /* Путь к файлу со шрифтом */
    font-weight: 600;
}

@font-face {
    font-family: 'Montserrat'; /* Имя шрифта */
    src: url('./assets/fonts/Montserrat/Montserrat-Bold.otf'); /* Путь к файлу со шрифтом */
    font-weight: bold;
}

.go-home-site {
    font-weight: 600;
    font-size: 16px;
    color: #67768C;
    display: flex;
    align-items: center;
    text-decoration: none !important;
    transition: 0.3s ease;
}
.go-home-site::before {
    content: '';
    display: inline-block;
    background: url('@/assets/img/go-home-site.svg') center;
    width: 18px;
    height: 16px;
    margin-right: 15px;
    transition: 0.3s ease;
}
.go-home-site:hover::before {
    transform: translateX(-5px);
}
.go-home-site span {
    white-space: nowrap;
}


.krust .container {
    padding: 0 70px;
}

.krust .content .container {
    padding: 0 70px;
    position: relative;
}


.notification {
    width: 320px;
    padding: 23px 30px 30px;
    background: #F56C6C;
    box-shadow: 0px 4px 30px rgba(245, 108, 108, 0.5);
    border-radius: 20px;
    position: fixed;
    top: 40px;
    right: 50px;
    color: #fff;
    font-size: 15px;
    z-index: 210;

    .notif-head {
        font-weight: 600;
        line-height: 100%;
        margin-bottom: 8px;
    }

    .notif-text {
        font-weight: 500;
        line-height: 140%;
        letter-spacing: 0.2px;
    }

    .close-notifi {
        background: url('assets/img/close-notifi.svg') center no-repeat;
        background-size: 12px;
        width: 12px;
        height: 12px;
        position: absolute;
        right: 15px;
        top: 15px;
        cursor: pointer;
    }
}

.notification.small {
    width: 44px;
    height: 44px;
    border-radius: 100%;
    padding: 0;
    box-shadow: 0px 4px 14px rgba(245, 108, 108, 0.3);
    position: initial;
    cursor: pointer;
    z-index: 100;

    .notif-head, .notif-text {
        display: none;
    }
}

.notification.small::after {
    background: url('assets/img/bell.svg') center no-repeat;
    background-size: 16px;
    width: 44px;
    height: 44px;
    content: '';
    display: block;
}


html {
    position: relative;
    min-height: 100%;
}

body {
    font-family: 'Montserrat' !important;
    font-size: 18px;
    overflow-x: hidden !important;
    background: url('assets/img/timetable-bg.svg') center top no-repeat;
    background-size: contain !important;
    background-position-y: 50px;
}

.content {
    margin-bottom: 145px;
}

.loader {
    height: 40px;
    width: 40px;
    margin: auto;
    position: absolute;
    top: 0;
    left:0 ;
    right: 0;
    bottom: 0;
    animation: rotation 1s infinite linear;
    border: 4px solid #dadce3;
    border-radius: 100%;
}

.loader.lessonLoader {
    bottom: initial;
    top: 120px;
}

.loader:before {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    top: -4px;
    height:100%;
    width:100%;
    border-top: 4px solid #1e51ba;
    border-left: 4px solid transparent;
    border-bottom: 4px solid transparent;
    border-right: 4px solid transparent;
    border-radius: 100%;
}

@-webkit-keyframes rotation {
    from {-webkit-transform: rotate(0deg);}
    to {-webkit-transform: rotate(359deg);}
}
@-moz-keyframes rotation {
    from {-moz-transform: rotate(0deg);}
    to {-moz-transform: rotate(359deg);}
}
@-o-keyframes rotation {
    from {-o-transform: rotate(0deg);}
    to {-o-transform: rotate(359deg);}
}
@keyframes rotation {
    from {transform: rotate(0deg);}
    to {transform: rotate(359deg);}
}


.tt-h2 {
    font-weight: 600;
    font-size: 28px;
    color: #000;
    margin-bottom: 34px;
    line-height: 120%;
}


header.header-min {
    padding-top: 43px;
    padding-bottom: 43px;
    min-height: 130px;
}

header .header-top {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
}

header .header-top-section {
    display: flex;
    column-gap: 30px;
    width: 100%;
    justify-content: end;
}

.logo {
    background: url(assets/img/logo.svg) no-repeat;
    width: 436px;
    height: 43px;
    background-size: contain !important;
    position: relative;
    display: table;
    transition: 0.3s ease;
}
.logo:hover {
    opacity: 0.7;
}

footer {
    display: flex;
    justify-content: space-between;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 70px auto 30px;

    .copy {
        font-size: 15px;
        font-weight: 500;
        color: #67768c;
    }

    .foot-link {
        font-size: 15px;
        font-weight: 500;
        color: #1E51BA;
        display: table;
    }
}

@media (min-width: 769px) {
    footer {
        margin-bottom: 30px !important;
    }
}


@media (max-width: 768px) {
    body {
        background-size: 150%;
    }

    .logo {
        width: 24px;
        height: 43px;
        background-size: 400px !important;
        margin-right: auto;
    }

    .go-home-site span {
        display: none;
    }

    .header-top {
        position: relative;
    }

    header.header-min {
        padding: 30px 0;
        min-height: initial;
    }

    .tt-h2 {
        margin-bottom: 20px;
        font-size: 23px;
        line-height: 130%;
    }

    .notification {
        left: 0;
        margin: 0 auto;
        right: 0;
    }

    .notification.small {
        right: 0;
        position: absolute;
        left: initial;
        top: 0;
    }

    footer {
        display: table;
        position: initial;
        margin: 0;
        margin-bottom: 40px;

        .copy {
            margin-bottom: 15px;
        }
    }

    .content {
        margin-bottom: 0px;
    }
}
</style>
